'use client'

import { Link } from 'react-router-dom'
import { ArrowLeft, Briefcase } from 'lucide-react'

export default function CareersPage() {
  return (
    <div className="min-h-screen bg-stone-50">
      <header className="bg-white border-b border-stone-200 sticky top-0 z-10">
        <div className="max-w-4xl mx-auto px-4 py-4 flex items-center justify-between">
          <Link to="/" className="flex items-center space-x-2 text-stone-600 hover:text-emerald-600 transition-colors">
            <ArrowLeft className="w-5 h-5" />
            <span className="font-medium">Back to Home</span>
          </Link>
          <Link to="/" className="flex items-center space-x-2">
            <img src="/logo.png" alt="LandlordNoAgent Logo" className="w-12 h-12 object-contain" />
            <span className="text-lg font-bold text-stone-800">
              Landlord<span className="text-emerald-600">NoAgent</span>
            </span>
          </Link>
        </div>
      </header>

      <main className="max-w-4xl mx-auto px-4 py-12">
        <div className="text-center mb-10">
          <div className="inline-flex items-center justify-center w-16 h-16 bg-emerald-100 rounded-full mb-4">
            <Briefcase className="w-8 h-8 text-emerald-600" />
          </div>
          <h1 className="text-3xl md:text-4xl font-display font-bold text-stone-900 mb-3">
            Careers
          </h1>
          <p className="text-lg text-stone-600 max-w-2xl mx-auto">
            Help us build a fairer rental market in Nigeria—direct connections between landlords and tenants, without unnecessary middlemen.
          </p>
        </div>

        <div className="bg-white rounded-2xl shadow-sm border border-stone-200 p-8 md:p-12 text-center">
          <h2 className="text-xl font-semibold text-stone-900 mb-3">No open roles right now</h2>
          <p className="text-stone-600 leading-relaxed max-w-xl mx-auto mb-8">
            We are not hiring at the moment. When positions become available, we will share them here. Thank you for your interest in LandLordNoAgent.
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <Link
              to="/"
              className="inline-flex items-center justify-center px-6 py-3 bg-emerald-600 text-white rounded-xl font-semibold hover:bg-emerald-700 transition-colors"
            >
              Back to Home
            </Link>
            <a
              href="mailto:careers@landlordnoagent.com?subject=Future%20opportunities%20at%20LandLordNoAgent"
              className="inline-flex items-center justify-center px-6 py-3 bg-white text-stone-700 rounded-xl font-semibold border border-stone-300 hover:bg-stone-50 transition-colors"
            >
              Register interest
            </a>
          </div>
          <p className="text-sm text-stone-500 mt-6">
            For general questions, visit our{' '}
            <Link to="/help" className="text-emerald-600 hover:text-emerald-700 font-medium">
              Help Center
            </Link>
            .
          </p>
        </div>
      </main>
    </div>
  )
}
